<template>
  <vx-card :title="$t('labels.user_detail')" class="user-listing">
    <router-link :to="{ name: 'AddUser' }" class="user-add-link">
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="float-right btn-add user-add-btn"
        v-if="checkPermission('user', 'add')"
        >{{ $t("labels.add_user") }}
      </vs-button>
    </router-link>
    <vs-tabs v-model="tab">
      <vs-tab
        :label="$t('labels.admin')"
        class="users"
        v-if="
          $store.state.userInfo.type === 'A' ||
          $store.state.userInfo.type === 'CN'
        "
      >
        <admin ref="adminref"></admin>
      </vs-tab>
      <vs-tab :label="$t('labels.client')" class="users">
        <client ref="clientref"></client>
      </vs-tab>
      <vs-tab
        :label="$t('labels.consultant')"
        class="users"
        v-if="
          $store.state.userInfo.type === 'A' ||
          $store.state.userInfo.type === 'CN'
        "
      >
        <consultant ref="consultantref"></consultant>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";
import Client from "@/layouts/components/users/client.vue";
import Admin from "@/layouts/components/users/admin.vue";
import Consultant from "@/layouts/components/users/consultant.vue";
import { EventBus } from "@/mixins/mixin.js";

export default {
  components: {
    KeyIcon,
    Client,
    Admin,
    Consultant,
  },
  data() {
    return {
      tab: this.$store.state.tab,
      adminCount: 0,
      flag: 0,
    };
  },
  computed: {
    userType() {
      if (
        this.$store.state.userInfo.type === "A" ||
        this.$store.state.userInfo.type === "CN"
      ) {
        if (this.tab === 0) {
          return "A";
        } else if (this.tab === 1) {
          return "CL";
        } else if (this.tab === 2) {
          return "CN";
        } else {
          return null;
        }
      } else {
        return "CL";
      }
    },
    admins: {
      get() {
        return this.$store.state.userData.admins;
      },
      set(value) {
        this.$store.commit("updateAdminData", value, { module: "userData" });
      },
    },
    clients: {
      get() {
        return this.$store.state.userData.clients;
      },
      set(value) {
        this.$store.commit("updateClientData", value, { module: "userData" });
      },
    },
    consultants: {
      get() {
        return this.$store.state.userData.consultants;
      },
      set(value) {
        this.$store.commit("updateConsultantData", value, {
          module: "userData",
        });
      },
    },
    index: {
      get() {
        return this.$store.state.userData.index;
      },
      set(value) {
        this.$store.commit("updateIndex", value, { module: "userData" });
      },
    },
  },
  watch: {
    tab() {
      if (
        (!this.admins.length && this.userType === "A") ||
        (!this.clients.length && this.userType === "CL") ||
        (!this.consultants.length && this.userType === "CN")
      ) {
        this.userList(this.userType);
      }
    },
  },
  mounted() {
    this.userList(this.userType);
    let that = this;
    // let perpage = process.env.VUE_APP_PER_PAGE;
    // if (localStorage.getItem("limit")) {
    //   let perpage = localStorage.getItem("limit");
    // }

    EventBus.$on("deleteConfirm", function (index) {
      that.deleteConfirm(index);
    });
    EventBus.$on("blockConfirm", function (index) {
      that.blockConfirm(index);
    });
    EventBus.$on("resetPassConfirm", function (index) {
      that.resetPassConfirm(index);
    });
    EventBus.$on("pageChanged", function (type) {
      that.userList(type);
    });
    EventBus.$on("limitChanged", function (type) {
      that.userList(type);
    });
    EventBus.$on("filter", function (type) {
      that.userList(type);
    });
    EventBus.$on("export", function (type) {
      that.userList(type, true);
    });
    EventBus.$on("import", function (type) {
      that.userList(type);
    });
  },
  methods: {
    async userList(type, exp = false) {
      let page;
      let input = {};
      let limit;
      if (type === "A") {
        page = this.$store.state.userData.adminCurrent;
        limit = this.$store.state.userData.adminLimit;

        if (this.$store.state.userData.adminSearch != null) {
          input["search"] = this.$store.state.userData.adminSearch;
        }
        if (this.$store.state.userData.adminBlock != null) {
          input["only_blocked"] = this.$store.state.userData.adminBlock;
        }
      } else if (type === "CL") {
        page = this.$store.state.userData.clientCurrent;
        limit = this.$store.state.userData.clientLimit;
        if (this.$store.state.userData.clientSubtype) {
          input["sub_type"] = this.$store.state.userData.clientSubtype;
        }

        if (this.$store.state.userInfo.subtype && !input.sub_type) {
          if (this.$store.state.userInfo.subtype === "OW" && !input.sub_type) {
            input["sub_type__in"] = "OW,M,OF,F";
          } else {
            input["sub_type"] = this.$store.state.userInfo.subtype;
          }
        }
        if (this.$store.state.userData.clientSearch) {
          input["search"] = this.$store.state.userData.clientSearch;
        }
        if (this.$store.state.userData.clientBlock) {
          input["only_blocked"] = this.$store.state.userData.clientBlock;
        }
      } else {
        page = this.$store.state.userData.consultantCurrent;
        limit = this.$store.state.userData.consultantLimit;
        if (this.$store.state.userData.consultantSearch != null) {
          input["search"] = this.$store.state.userData.consultantSearch;
        }
        if (this.$store.state.userData.consultantBlock != null) {
          input["only_blocked"] = this.$store.state.userData.consultantBlock;
        }
      }
      input["type"] = type;
      input["perPage"] = limit;
      input["page"] = page;
      if (exp) {
        input["export"] = 1;
      }

      let response = await this.getHTTPPostResponse("/users", input);
      if (exp) {
        this.exportFile(response, "Users");
      }
      if (response.data) {
        let data = response.data.users;
        if (this.userType === "A") {
          this.admins = data;
          let perPage = this.$store.state.userData.adminLimit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.$store.commit("updateAdminCount", totalPage, {
            module: "userData",
          });
          this.$store.commit("updateAdminSampleCsv", response.data.sample_csv, {
            module: "userData",
          });
        }
        if (this.userType === "CL") {
          this.clients = data;

          let perPage = this.$store.state.userData.clientLimit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.$store.commit("updateClientCount", totalPage, {
            module: "userData",
          });
        }
        if (this.userType === "CN") {
          this.consultants = data;
          let perPage = this.$store.state.userData.consultantLimit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.$store.commit("updateConsultantCount", totalPage, {
            module: "userData",
          });
        }
      }
    },
    deleteConfirm(index) {
      let lead_delete = "";
      if (this.userType === "CN") {
        lead_delete = this.consultants[index];
      }
      if (this.userType === "CL") {
        lead_delete = this.clients[index];
      }
      if (this.userType === "A") {
        lead_delete = this.admins[index];
      }
      let text;
      if (lead_delete.lead && lead_delete.lead.id) {
        text = this.$t("strings.delete_lead_confirm");
      } else {
        text = this.$t("strings.delete_confirm");
      }
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: text,
        accept: this.deleteUser,
      });
    },
    async deleteUser() {
      if (this.index < 0) return;
      let url = "/users/delete";
      let ids = [];
      let index = this.index;
      if (this.userType === "A") {
        ids.push(this.admins[index].id);
      }
      if (this.userType === "CL") {
        ids.push(this.clients[index].id);
      }
      if (this.userType === "CN") {
        ids.push(this.consultants[index].id);
      }
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        //this.admins.splice(index,1);
        this.userList(this.userType);
      }
    },
    blockConfirm(index) {
      this.index = index;
      let text;
      let is_blocked;
      let title;
      if (this.userType === "A") {
        is_blocked = this.admins[index].is_blocked;
      }
      if (this.userType === "CL") {
        is_blocked = this.clients[index].is_blocked;
      }
      if (this.userType === "CN") {
        is_blocked = this.consultants[index].is_blocked;
      }
      if (!is_blocked) {
        text = this.$t("strings.block_confirm");
        title = this.$t("labels.block");
      } else {
        text = this.$t("strings.unblock_confirm");
        title = this.$t("labels.unblock");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: title,
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: text,
        accept: this.updateStatus,
      });
    },
    async updateStatus() {
      if (this.index < 0) return;
      let ids = [];
      let index = this.index;
      let is_blocked;
      if (this.userType === "A") {
        ids.push(this.admins[index].id);
        is_blocked = this.admins[index].is_blocked;
      }
      if (this.userType === "CL") {
        ids.push(this.clients[index].id);
        is_blocked = this.clients[index].is_blocked;
      }
      if (this.userType === "CN") {
        ids.push(this.consultants[index].id);
        is_blocked = this.consultants[index].is_blocked;
      }

      let input = {
        is_blocked: !is_blocked,
        ids: ids,
      };
      let url = "/users/change-status";
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.index = -1;
        this.userList(this.userType);
      }
    },
    resetPassConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.reset_password"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.reset_pass_confirm"),
        accept: this.resetPassword,
      });
    },
    async resetPassword() {
      if (this.index < 0) return;
      let index = this.index;
      let id;
      if (this.userType === "A") {
        id = this.admins[index].id;
      }
      if (this.userType === "CL") {
        id = this.clients[index].id;
      }
      if (this.userType === "CN") {
        id = this.consultants[index].id;
      }
      let url = "/users/reset-password/" + id;
      let response = await this.getHTTPPostResponse(url, {}, null, true);
      if (response) {
        this.index = -1;
        this.userList(this.userType);
      }
    },
    clearImport() {
      document.getElementById("file").value = "";
      this.userList();
    },
  },
};
</script>
